// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39z5D","input":"styles_input__3Na6F"};